import { createContext, useContext } from 'react';

type SidebarContextType = {
  onClose?: () => void;
};

const SidebarContext = createContext<SidebarContextType>({});

export const SidebarProvider = SidebarContext.Provider;

export const useSidebarContext = () => {
  return useContext(SidebarContext);
};
